module.exports = "/_next/static/images/halcyonmobile-logo-440b06609708536d6aecae56d170142b.svg";